import { render, staticRenderFns } from "./CadastroConsulta.vue?vue&type=template&id=4d3f3958&scoped=true&"
import script from "./CadastroConsulta.vue?vue&type=script&lang=js&"
export * from "./CadastroConsulta.vue?vue&type=script&lang=js&"
import style0 from "./CadastroConsulta.vue?vue&type=style&index=0&id=4d3f3958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f3958",
  null
  
)

export default component.exports